import {initializeApp} from "firebase/app";
import {connectAuthEmulator, getAuth} from "@firebase/auth";
import {getEnv, isDev, isProd, isStaging} from "../env/env";
import i18n from "i18next";

const firebaseDevConfig = {
  apiKey: "AIzaSyCCNjvmILUhEIhAJTVJLY7x9T8nqTmAlFA",
  authDomain: getAuthDomain(),
  projectId: "accounts-ccbf4",
  storageBucket: "accounts-ccbf4.appspot.com",
  messagingSenderId: "788540597720",
  appId: "1:788540597720:web:63464c41ac4a96875ebead",
};

const firebaseProdConfig = {
  apiKey: "AIzaSyDGVUhrobYjnoRRskMIfXl6KSafhAM0YNY",
  authDomain: getAuthDomain(),
  projectId: "wakelet-auth",
  storageBucket: "wakelet-auth.appspot.com",
  messagingSenderId: "351092759336",
  appId: "1:351092759336:web:5da0a9433699bd6b7a0e1d",
};

function getFirebaseConfig() {
    if (isProd()) {
    return firebaseProdConfig;
  }
  return firebaseDevConfig;
}

const app = initializeApp(getFirebaseConfig());

export const auth = getAuth(app);
const env = getEnv();
if (env === "development" || env === "test") {
  console.info("connecting emulator")
  connectAuthEmulator(auth, "http://localhost:9099");
}

i18n.on("languageChanged", (lang) => {
  auth.languageCode = lang;
});

function getAuthDomain() {
  if (isDev()) {
    return "accounts.localhost.wakelet.com";
  }
  if (isStaging()) {
    return "alpha-accounts.staging.wakelet.com";
  }
  return "alpha-accounts.wakelet.com";
}
